export default "__VITE_ASSET__Byi0G2Rr__"